import React from "react";
import { FaEnvelope } from "react-icons/fa";
import { RiWhatsappFill, RiSendPlaneFill } from "react-icons/ri";
import { MdLocationPin } from "react-icons/md";
import { BiTime } from "react-icons/bi";
import { IoCall } from "react-icons/io5";
import "./Contact.style.css";
import { IoIosArrowUp } from "react-icons/io";
import WebData from "../../Helpers/WebData";

const Contact = () => {
  const address = WebData.contact.address;
  const dayslist = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  var dayArray = WebData.contact.dayArray;
  return (
    <section className="sectiontopPadding contact top-nav-space" id="contact">
      <div className="container">
        <h3 className="global-heading text-center">Contact</h3>
      </div>
      {/* Google map.... */}
      <div className="fade-in-map">
        <iframe
          style={{ border: "0", width: "100%", height: "350px" }}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3920.771512700217!2d75.99967621462162!3d10.674835342390509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7be0fa3dce9ad%3A0x5f69ce37d7c9389a!2sAttupuram%2C%20Punnayurkulam%2C%20Kerala%20679561!5e0!3m2!1sen!2sin!4v1644211949104!5m2!1sen!2sin"
          frameBorder="0"
          allowFullScreen
          title="location-map"
        ></iframe>
      </div>
      {/* contact-information */}
      <div className="contact_wrapper">
        <div className="mx-md-5 mx-1">
          <div className="my-2 row" style={{ maxWidth: "100vw" }}>
            <div className="d-flex flex-column justify-content-left col-12 col-md-6">
              <div className="">
                <div className="address_box">
                  <div className="icon_box_contact">
                    <span className="align-self-center">
                      <MdLocationPin className="icon-contact" />
                    </span>
                  </div>
                  <p
                    className="align-self-center"
                    style={{ color: "rgba(150, 150, 0, 1)" }}
                  >
                    {address}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-2 d-flex align-items-center justify-content-md-center">
              <div className="">
                <div className="time_box">
                  <div className="icon_box_contact">
                    <span className="align-self-center">
                      <BiTime className="icon-contact" />
                    </span>
                  </div>
                  <div className="time_box">
                    <button className="time_btn">
                      Timing <IoIosArrowUp />
                    </button>
                    <div className="box_content">
                      {dayArray.length &&
                        dayArray.map((openclose, index) =>
                          openclose[0] === "closed" ? (
                            <p key={index}>{dayslist[index]}: closed</p>
                          ) : (
                            <p key={index}>
                              {dayslist[index]}: {openclose[0]}:{openclose[1]} -{" "}
                              {openclose[2]}:{openclose[3]}
                            </p>
                          )
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-4 justify-content-center align-items-center align-self-center h-100">
              <div className="contact_box d-flex justify-content-center">
                <div className="icon_group">
                  <div className="icon_box_contact">
                    <a
                      href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;tf=1&amp;to=aa.lttrends@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-icon"
                    >
                      <FaEnvelope className="icon-contact" />
                    </a>
                  </div>
                  <div className="icon_box_contact">
                    <a href="tel:+91 98679 10690" className="contact-icon">
                      <IoCall className="icon-contact" />
                    </a>
                  </div>
                  <div className="icon_box_contact">
                    <a
                      href="//api.whatsapp.com/send?phone=+91 98679 10690"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-icon"
                    >
                      <RiWhatsappFill className="icon-contact" />
                    </a>
                  </div>
                  <div className="icon_box_contact me-0">
                    <a
                      href="https://telegram.me/make605"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-icon"
                    >
                      <RiSendPlaneFill className="icon-contact" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
